import getMuiTheme from 'material-ui/styles/getMuiTheme';

import colors from './colors';

const theme = getMuiTheme({
  palette: {
    primary1Color: colors.PRIMARY,
    primary2Color: colors.SECONDARY,
    alternateTextColor: colors.DARK_GREY,
  },
  raisedButton: {
    color: colors.WHITE,
    disabledColor: colors.WHITE,
    disabledTextColor: colors.LIGHT_GREY,
    primaryTextColor: colors.WHITE,
    secondaryTextColor: colors.PRIMARY,
    secondaryColor: colors.SECONDARY,
  },
  flatButton: {
    primaryTextColor: colors.BLUE,
    secondaryTextColor: colors.SECONDARY,
  },
  menuItem: {
    selectedTextColor: colors.PRIMARY,
  },
  datePicker: {
    textColor: colors.WHITE,
    selectTextColor: colors.WHITE,
    selectColor: colors.PRIMARY,
  },
  stepper: {
    textColor: colors.LIGHT_GREY,
  },
});

export default theme;



// WEBPACK FOOTER //
// ./theme/index.js